export const required = (value: any) => (value ? undefined : "Can't be blank");

export const isEmail = (value: string, skipPresence?: boolean) => {
  if (skipPresence && !value) {
    return undefined
  }

  const emailRegexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return value && emailRegexp.test(value)
    ? undefined
    : "Email is invalid";
}
